import React from "react";
import { GsdReadableBlock } from "../../components/GsdReadableBlock.jsx";
import { GsdPageHeader } from "../../components/GsdPageHeader.jsx";
import { GsdQuickActions, GsdStatGrid } from "../../components/GsdQuickActions.jsx";
import { resolveStandaloneModuleLabel } from "./createStandaloneModuleConfig.js";

/**
 * Dashboard générique — résumé, stats, actions rapides, blocs pédagogiques.
 */
export function GsdStandaloneModuleDashboard({
  title,
  subtitle,
  icon,
  lang = "fr",
  summaryCards = [],
  quickActions = [],
  renderQuickAction,
  infoBlocks,
  notice,
  children,
  testId = "gsd-standalone-module-dashboard",
}) {
  const locale = lang === "en" ? "en" : "fr";
  const resolvedTitle = typeof title === "string" ? title : resolveStandaloneModuleLabel(locale, title);
  const resolvedSubtitle =
    typeof subtitle === "string"
      ? subtitle
      : subtitle
        ? resolveStandaloneModuleLabel(locale, subtitle)
        : null;

  return (
    <GsdReadableBlock testId={testId} className="gsd-standalone-module-dashboard" variant="default">
      <GsdPageHeader
        title={icon ? `${icon} ${resolvedTitle}` : resolvedTitle}
        subtitle={resolvedSubtitle}
        testId={`${testId}-header`}
      />

      {notice ? (
        <div className="gsd-standalone-module-dashboard__notice" data-testid={`${testId}-notice`}>
          {typeof notice === "string" ? <p>{notice}</p> : notice}
        </div>
      ) : null}

      {summaryCards.length ? (
        <section className="gsd-standalone-module-dashboard__summary" data-testid={`${testId}-summary`}>
          <GsdStatGrid items={summaryCards} testId={`${testId}-stat-grid`} />
        </section>
      ) : null}

      {quickActions.length ? (
        <section className="gsd-standalone-module-dashboard__actions" data-testid={`${testId}-quick-actions`}>
          <GsdQuickActions
            actions={quickActions}
            renderAction={renderQuickAction}
            testId={`${testId}-actions`}
          />
        </section>
      ) : null}

      {infoBlocks ? (
        <div className="gsd-standalone-module-dashboard__info" data-testid={`${testId}-info`}>
          {infoBlocks}
        </div>
      ) : null}

      {children ? <div data-testid={`${testId}-children`}>{children}</div> : null}
    </GsdReadableBlock>
  );
}
